import { isRejectedWithValue } from "@reduxjs/toolkit";
import type { MiddlewareAPI, Middleware } from "@reduxjs/toolkit";
import { setMessage } from "@store/snackbarSlice";
import i18n from "i18next";
import { setOpen } from "@store/offlineBannerSlice";

export const apiErrorHandler: Middleware =
  (api: MiddlewareAPI) => (next) => async (action) => {
    if (
      isRejectedWithValue(action) &&
      (action.meta as any)?.baseQueryMeta?.response?.status === 401
    ) {
      //await SignOutService.instance.signOut(api.dispatch);
      //return;
    }
    if (
      isRejectedWithValue(action) &&
      (action.meta as any)?.baseQueryMeta?.request?.method === "GET"
    ) {
      if (
        (action.payload as any)?.status === "FETCH_ERROR" &&
        api.getState()?.auth?.user
      ) {
        api.dispatch(setOpen(true));
      } else {
        api.dispatch(
          setMessage({
            content: i18n.t("errors.unknown"),
            severity: "error",
          }),
        );
      }
    }

    return next(action);
  };
